export default {
    props: {
        titleAlign: {
            type: String,
            default: undefined,
            kComposite: 'title.align'
        }, 
        titleBackground: {
            type: String,
            default: undefined,
            kComposite: 'title.background'
        }, 
        titleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'title.border.color'
        }, 
        titleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'title.border.dashType'
        }, 
        titleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'title.border.width'
        }, 
        titleColor: {
            type: String,
            default: undefined,
            kComposite: 'title.color'
        }, 
        titleFont: {
            type: String,
            default: undefined,
            kComposite: 'title.font'
        }, 
        titleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin'
        }, 
        titleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.bottom'
        }, 
        titleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.left'
        }, 
        titleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.right'
        }, 
        titleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'title.margin.top'
        }, 
        titlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding'
        }, 
        titlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.bottom'
        }, 
        titlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.left'
        }, 
        titlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.right'
        }, 
        titlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'title.padding.top'
        }, 
        titlePosition: {
            type: String,
            default: undefined,
            kComposite: 'title.position'
        }, 
        titleText: {
            type: String,
            default: undefined,
            kComposite: 'title.text'
        }, 
        titleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'title.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Title.js